import { withStyles } from '@material-ui/core';
import React from 'react';

const styles = (theme) => ({
  sectionTitle: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
    fontWeight: 500
  },
  subSectionTitle: {
    textTransform: 'uppercase',
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    marginBottom: '12px'
  },
  shipmentDetailsContent: {
    width: '100%',
    marginTop: 8,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: '50px',
    justifyContent: 'space-between'
  },
  shipmentDetailItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  shipmentDetailValue: {
    fontSize: theme.headerTextFontSize16,
    fontWeight: 600,
    color: theme.disableButtonText
  },
  shipmentDetailLabel: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor
  }
});
const SelectedShipmentDetails = ({ classes, data }) => {
  return (
    <div className={classes.fieldSet}>
      <div className={classes.sectionTitle}>Selected Shipment Details</div>
      <div className={classes.shipmentDetailsContent}>
        {data.shipmentDetails &&
          Object.keys(data.shipmentDetails).map((key) => (
            <div key={key} className={classes.shipmentDetailItem}>
              <div className={classes.shipmentDetailValue}>{data.shipmentDetails[key]}</div>
              <div className={classes.shipmentDetailLabel}>{key}</div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default withStyles(styles)(SelectedShipmentDetails);
